import i18n from 'src/i18n.js';

export const ADDPRODUCTMETHODS = (value) => [
    {
        name: i18n.t('common.productGuideTitle'),
        title: 'common.productGuideTitle',
        id: 'Product Guide',
        isVisible: value?.includes('Product Guide'),
    },
    {
        name: i18n.t('common.productTemplatesTitle'),
        title: 'common.productTemplatesTitle',
        id: 'Product Templates',
        isVisible: value?.includes('Product Templates'),
    },
    {
        name: i18n.t('common.quickOrderTitle'),
        title: 'common.quickOrderTitle',
        id: 'Quick Order',
        isVisible: value?.includes('Quick Order'),
    },
    {
        name: i18n.t('common.productSearchTitle'),
        title: 'common.productSearchTitle',
        id: 'Product Search',
        isVisible: value?.includes('Product Search'),
    },
    {
        name: i18n.t('common.bulkAddList'),
        title: 'common.bulkAddList',
        id: 'Bulk Add List',
       isVisible: value?.includes('Bulk Add List'),
    },
];
export const COUNTRY_CODE_JAPN = 'JP';
// export const ADDITIONAL_PROCEDURE_DATA = [
//     {
//         code: '01',
//         description: 'Powerease',
//         isSelected: null,
//     },
//     {
//         code: '02',
//         description: 'Stealth S7/S8 Navigation',
//         isSelected: null,
//     },
//     {
//         code: '03',
//         description: 'Advanced Energy',
//         isSelected: null,
//         advancedEnergyProduct: {
//             isPlasmaBladeX: true,
//             isAquamantys: true,
//         },
//     },
//     {
//         code: '04',
//         description: 'MazorX Robot Used',
//         isSelected: null,
//         mazorKitCode: '',
//     },
// ];
export const CONSIGNMENTADDPRODUCTMETHODS = () => [
    {
        name: i18n.t('common.productGuideTitle'),
        title: 'common.productGuideTitle',
    },
    { name: i18n.t('common.quickOrderTitle'), title: 'common.quickOrderTitle' },
    {
        name: i18n.t('common.productSearchTitle'),
        title: 'common.productSearchTitle',
    },
    {
        name: i18n.t('common.bulkAddList'),
        title: 'common.bulkAddList',
        id: 'Bulk Add List',
    },
];
export const PROCEDURE_PAGE_DATA = {
    additionalProcedureData: [
        { name: 'Powerease', code: '01' },
        { name: 'Stealth S7/S8 Navigation', code: '02' },

        { name: 'Advanced Energy', code: '03' },
        { name: 'MazorX Robot Used', code: '04' },
    ],
    deformityCorrectionData: [
        { code: '87', name: 'None' },
        { code: '86', name: 'Smartlink' },
    ],
    biologicsUsedData: [
        { name: 'None', code: '01' },
        { name: 'Yes (Medtronic/Competitive)', code: '02' },
        { name: 'Autograft/Patient Derived', code: '03' },
    ],
    physicianFinderEligibilityData: [
        { name: 'None', code: 'n/a' },
        { name: '3D Image Guided/Navigation', code: '22' },
        { name: 'Back Surgery', code: '20' },
        { name: 'Cervical Disc Arthroplasty', code: '19' },
        { name: 'Sacroiliac Joint Fusion', code: '23' },
        { name: 'Scoliosis', code: '24' },
        { name: 'Spine Robotics', code: '32' },
    ],
    biologicsDetailData: [
        {
            name: 'Allograft@ex: Cornerstone, Chips and Cubes',
            code: '01',
        },
        { name: 'Proteins/Peptides@ex: Infuse', code: '02' },
        { name: 'Stem Cell Products@ex: CBMs, VBMs', code: '03' },
        { name: 'DBM@ex: Grafton, Magnifuse', code: '04' },
        { name: 'Synthetics@ex: Mastergraft', code: '05' },
    ],
    retractorUsedData: [
        { name: 'None', code: '0001' },
        { name: 'McCulloch Retractor', code: '0002' },
        { name: 'ALOP', code: '0003' },
        { name: 'Tedan Phantom', code: '0004' },
        { name: 'Precision', code: '0005' },
        { name: 'Thompson OLIF25', code: '0006' },
        { name: 'Thompson OLIF51', code: '0007' },
        { name: 'Thompson ALIF Ring Retractor', code: '0008' },
        { name: 'DLIF (Older Gen.)', code: '0009' },
        { name: 'Trimline', code: '0010' },
        {
            name: 'Space D Distractor-Compressor System',
            code: '0011',
        },
        { name: 'Quadrant Retractor', code: '0012' },
        { name: 'METRx', code: '0013' },
        { name: 'ModuleX Midline Retractor', code: '0014' },
        { name: 'Other', code: '0015' },
    ],
    levels: [
        {
            code: '01',
            description: 'C1',
            isSelected: null,
        },
        {
            code: '02',
            description: 'C2',
            isSelected: null,
        },
        {
            code: '03',
            description: 'C3',
            isSelected: null,
        },
        {
            code: '04',
            description: 'C4',
            isSelected: null,
        },
        {
            code: '05',
            description: 'C5',
            isSelected: null,
        },
        {
            code: '06',
            description: 'C6',
            isSelected: null,
        },
        {
            code: '07',
            description: 'C7',
            isSelected: null,
        },
        {
            code: '08',
            description: 'T1',
            isSelected: null,
        },
        {
            code: '09',
            description: 'T2',
            isSelected: null,
        },
        {
            code: '10',
            description: 'T3',
            isSelected: null,
        },
        {
            code: '11',
            description: 'T4',
            isSelected: null,
        },
        {
            code: '12',
            description: 'T5',
            isSelected: null,
        },
        {
            code: '13',
            description: 'T6',
            isSelected: null,
        },
        {
            code: '14',
            description: 'T7',
            isSelected: null,
        },
        {
            code: '15',
            description: 'T8',
            isSelected: null,
        },
        {
            code: '16',
            description: 'T9',
            isSelected: null,
        },
        {
            code: '17',
            description: 'T10',
            isSelected: null,
        },
        {
            code: '18',
            description: 'T11',
            isSelected: null,
        },
        {
            code: '19',
            description: 'T12',
            isSelected: null,
        },
        {
            code: '20',
            description: 'L1',
            isSelected: null,
        },
        {
            code: '21',
            description: 'L2',
            isSelected: null,
        },
        {
            code: '22',
            description: 'L3',
            isSelected: null,
        },
        {
            code: '23',
            description: 'L4',
            isSelected: null,
        },
        {
            code: '24',
            description: 'L5',
            isSelected: null,
        },
        {
            code: '25',
            description: 'S1',
            isSelected: null,
        },
        {
            code: '26',
            description: 'S2',
            isSelected: null,
        },
        {
            code: '27',
            description: 'Illium',
            isSelected: null,
        },
    ],
};
export const SCHEDULESURGERYSTEPS = ['Details', 'Cart', 'Shipping', 'Submit'];
export const SCHEDULESURGERYSTEPS_LABELS = [
    i18n.t('scheduleSurgery.progressBar.details'),
    i18n.t('scheduleSurgery.progressBar.cart'),
    i18n.t('scheduleSurgery.progressBar.shipping'),
    i18n.t('scheduleSurgery.progressBar.submit'),
];
export const ORDEREQUITYSTEPS = ['Account', 'Cart', 'Shipping', 'Submit'];
export const ORDEREQUITYSTEPS_LABELS = [
    i18n.t('equity.progressBar.account'),
    i18n.t('equity.progressBar.cart'),
    i18n.t('equity.progressBar.shipping'),
    i18n.t('equity.progressBar.submit'),
];
export const ORDER_CONSIGNMENT_ADD_STEPS = [
    'Account',
    'Cart',
    'Shipping',
    'Submit',
];

export const ORDER_CONSIGNMENT_ADD_STEPS_LABELS = [
    i18n.t('equity.progressBar.account'),
    i18n.t('equity.progressBar.cart'),
    i18n.t('equity.progressBar.shipping'),
    i18n.t('equity.progressBar.submit'),
];

export const REPORTPROGRESSTEP = ['Record', 'Replen', 'Procedure', 'Submit'];
export const REPORTPROGRESSTEPSWITHOUTPROCEDURE = [
    'Record',
    'Replen',
    'Submit',
];
export const REPORTPROGRESSTEPSWITHOUTREPLEN = [
    'Record',
    'Procedure',
    'Submit',
];
export const REPORTPROGRESSTEPSWITHOUTREPLENANDPROCEDURE = [
    'Record',
    'Submit',
];
export const REPORTPROGRESSTEP_LABELS = () => [
    i18n.t('reportUsage.progressBar.recordTitle'),
    i18n.t('reportUsage.progressBar.replen'),
    i18n.t('reportUsage.progressBar.procedure'),
    i18n.t('reportUsage.progressBar.submit'),
];
export const REPORTPROGRESSTEPSWITHOUTPROCEDURE_LABELS = () => [
    i18n.t('reportUsage.progressBar.recordTitle'),
    i18n.t('reportUsage.progressBar.replen'),
    i18n.t('reportUsage.progressBar.submit'),
];
export const CONSIGNMENTBILLINGPROGRESSTEPS = [
    'Account',
    'Billing',
    'Replen',
    'Payment',
    'Submit',
];
export const CONSIGNMENTRETURNPROGRESSTEPS = ['Account', 'Products', 'Submit'];

export const REPORTUSAGEBUTTON = () => [
    i18n.t('reportUsage.reportUsageFooterbuttons.replenishButton'),
    i18n.t('reportUsage.progressBar.procedure'),
    i18n.t('reportUsage.reportUsageFooterbuttons.reviewButton'),
    i18n.t('noUsageToReport.submitButton'),
];

export const PRODUCTVALIDATIONPOPUPMESSAGES = () => ({
    itemNotAvailable: {
        title: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAvailable.title'
        ),
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAvailable.heading1'
        ),
        heading2: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAvailable.heading2'
        ),
    },
    itemNotAvailableConsignmentAdd: {
        heading2: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAvailable.heading1'
        ),
    },
    itemNotAllowedAsExtra: {
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAllowedAsExtra.heading1'
        ),
    },
    itemNotAllowedAsExtraSurgery: {
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAllowedAsExtraSurgery.heading1'
        ),
    },
    setNotAllowedAsExtra: {
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.setNotAllowedAsExtra.heading1'
        ),
    },
    specialHandlingRequired: {
        title: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.title'
        ),
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.heading1'
        ),
    },
    itemNotAllowed: {
        title: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAllowed.title'
        ),
        button: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAllowed.button'
        ),
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.itemNotAllowed.heading1'
        ),
    },
});

export const PRODUCTVALIDATIONTEMPLATEPOPUPMESSAGES = () => ({
    specialHandlingRequired: {
        title: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.title'
        ),
        heading1: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.heading1'
        ),
        heading2: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.heading2'
        ),
        heading3: i18n.t(
            'productValidationMessages.productValidationPopupMessages.specialHandlingRequired.heading3'
        ),
    },
});

export const PRODUCT_TEMPLATE_VALIDATION_POPUPMESSAGES = () => ({
    itemNotAvailable: (count) => {
        return {
            title: i18n.t('productTemplateValidationPopUpMessages.title'),
            heading1: `${count} ${i18n.t(
                'productTemplateValidationPopUpMessages.heading1'
            )}`,
            heading2: i18n.t('productTemplateValidationPopUpMessages.heading2'),
        };
    },
    tenItemTitle: i18n.t('productTemplateValidationPopUpMessages.tenItemTitle'),
    itemNotAllowedAsExtra: i18n.t(
        'productTemplateValidationPopUpMessages.itemNotAllowedAsExtra'
    ),
});

export const ProductDetailsFilter = () => [
    {
        id: '3',
        title: i18n.t('filter.productDetailsFilter.title4'),
    },
    {
        id: '4',
        title: i18n.t('filter.productDetailsFilter.title3'),
    },
    {
        id: '1',
        title: i18n.t('filter.productDetailsFilter.title2'),
    },
    {
        id: '2',
        title: i18n.t('filter.productDetailsFilter.title1'),
    },
];
export const TISSUE_AND_NON_TISSUE_SALES_ORG = {
    tissue: 'S030',
    nonTissue: 'S002',
};

export const EQUITYCATEGORY = 'Equity';
export const CONSIGNMENT_ADD_CATEGORY = 'Consignment_Add';

export const CONSIGNMENTCATEGORY = 'Consignment';
export const CONSIGNMENTRETURNCATEGORY = 'ConsignmentReturn';
export const ORDEREQUITYINITAL = () => ({
    Account: {
        label: 'Account',
        displayLabel: i18n.t('equity.progressBar.account'),
        progress: 0,
        current: true,
        done: false,
    },
    Cart: {
        label: 'Cart',
        displayLabel: i18n.t('equity.progressBar.cart'),
        progress: 50,
        current: false,
        done: false,
    },
    Shipping: {
        label: 'Shipping',
        displayLabel: i18n.t('equity.progressBar.shipping'),
        progress: 0,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('equity.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
});
export const ORDERCONSIGNMENTADDINITAL = () => ({
    Account: {
        label: 'Account',
        displayLabel: i18n.t('equity.progressBar.account'),
        progress: 0,
        current: true,
        done: false,
    },
    Cart: {
        label: 'Cart',
        displayLabel: i18n.t('equity.progressBar.cart'),
        progress: 50,
        current: false,
        done: false,
    },
    Shipping: {
        label: 'Shipping',
        displayLabel: i18n.t('equity.progressBar.shipping'),
        progress: 0,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('equity.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
});
export const CONSIGNMENTINITIAL = () => ({
    Account: {
        label: 'Account',
        displayLabel: i18n.t('consignment.progressBar.account'),
        progress: 0,
        current: true,
        done: false,
    },
    Billing: {
        label: 'Billing',
        displayLabel: i18n.t('consignment.progressBar.billing'),
        progress: 50,
        current: false,
        done: false,
    },
    Replen: {
        label: 'Replen',
        displayLabel: i18n.t('consignment.progressBar.replen'),
        progress: 0,
        current: false,
        done: false,
    },
    Payment: {
        label: 'Payment',
        displayLabel: i18n.t('consignment.progressBar.payment'),
        progress: 0,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('consignment.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
});

export const CONSIGNMENTRETURNINITIAL = () => ({
    Account: {
        label: 'Account',
        displayLabel: i18n.t('consignment.progressBar.account'),
        progress: 0,
        current: true,
        done: false,
    },
    Products: {
        label: 'Products',
        displayLabel: i18n.t('consignmentReturn.billing.products'),
        progress: 50,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('consignment.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
});

export const GETEQUITYDETAILSDATA = {
    myCaseRef: '',
    resourceType: 'newEquityOrder',
};

export const GETCONSIGNMENTADDDETAILSDATA = {
    myCaseRef: '',
    resourceType: 'newConsignmentAddOrder',
};

export const GETEQUITYDETAILSFROMUSAGEDATA = {
    myCaseRef: '',
    resourceType: 'createEquity',
};

export const GETSURGERYDETAILSDATA = {
    myCaseRef: '',
    resourceType: 'newSurgeryOrder',
};

export const GETSURGERYDETAILSFROMUSAGEDATA = {
    myCaseRef: '',
    resourceType: 'createSurgery',
};

export const GETCONSIGNMENTDATA = {
    myCaseRef: '',
    resourceType: 'newConsignmentOrder',
};

export const GETCONSIGNMENTRETURNDATA = {
    myCaseRef: '',
    resourceType: 'newConsignmentReturnOrder',
};
export const CREDITCARDPAYMENTMESSAGE = () =>
    i18n.t('equity.common.constants.creditCardMsg');

export const EQUITYVALIDATEACCOUNT = {
    orderType: 'ZOR',
    sapPartnerId: '',
    soldtoId:'',
    district:'',
    territory: '',
};

export const KEVALIDATEACCOUNT = {
    orderType: 'KE',
    sapPartnerId: '',
    soldtoId:'',
    district:'',
    territory: '',
};

export const ZKAVALIDATEACCOUNT = {
    orderType: 'ZKA',
    sapPartnerId: '',
    soldtoId:'',
    district:'',
    territory: '',
};

export const BLOCKED_ACCOUNT_MESSAGE = () =>
    i18n.t('equity.account.blockedAccountMessage');

export const EQUITYORDERRESOURCETYPE = {
    newOrder: 'newEquityOrder',
    draftOrder: 'draft',
};
export const CONSIGNMENTADDORDERRESOURCETYPE = {
    newOrder: 'newEquityOrder',
    draftOrder: 'draft',
};
export const selectedMaterialTypes = ['ZKMT', 'DIEN', 'ZFRT'];
export const sectionSteps = {
    firstSection: 0,
    secondSection: 1,
    thirdSection: 3,
    fourthSection: 4,
};
export const REPORTUSAGEVALIDATEACCOUNT = {
    orderType: 'ZLC',
    sapPartnerId: '',
};
